import React, { Fragment } from 'react'
import { DI } from 'modules'
import HelmetWrap from 'components/helmet-wrap'
import Component from 'components/component'
import { DateTime } from 'luxon'
import page from 'hoc/page'
import frontload from 'hoc/frontload'
import 'submodules/responsivestyles/src/less/about.less'

export class TOSPage extends Component {
  static preload(props) {
    const slug = 'terms'
    return props.actions.frontpages.getFrontPage(slug)
  }

  render() {
    const tosInfo = this.props.tos.tosInfo.payload
    const meta_tag = this.props.frontpages.info.payload.meta_tag
    const strings = this.props.common.strings

    return (
      <Fragment>
        <HelmetWrap {...(meta_tag || {})} page="terms" />

        <section className="content">
          <div className="iwrap not-found-page">
            <div className="about-container">
              <div
                dangerouslySetInnerHTML={{
                  __html: tosInfo.content,
                }}
              />
              <div style={{ textAlign: 'right', marginTop: '30px' }}>
                {strings.last_updated_at || 'Last updated at'}{' '}
                {DateTime.fromISO(tosInfo.updated_at).toFormat('dd.MM.yyyy')}
              </div>
            </div>
          </div>
        </section>
      </Fragment>
    )
  }
}

export default page(DI(['frontpages', 'tos'])(frontload(TOSPage, 'tosPage')))
